module.exports = __webpack_public_path__ + "media/3_16.342b87d9.wav";